// removed by extract-text-webpack-plugin
module.exports = {"container__hidden":"_1c2IHsB","group":"_3RAMPY8","container":"_1gmIo4T","body":"_1ysB59M"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Footer/Links.css
// module id = ./template/components/Footer/Links.css
// module chunks = client.sitechrome